module.exports = __webpack_public_path__ + "img/33.87921084.webp";